'use client'
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import Select, {components} from "react-select";
import React, {useState} from "react";
import {hover} from "@/styles/globalStyleVars";
import DownloadSingle from "@/components/media/DownloadSingle";
import {usePathname} from "next/navigation";
import Button from "@/components/Button";
import {getResearchApi} from "@/api";
import DatePicker from "react-datepicker";


const MediaListing = ({data}) => {

    const pathname = usePathname();
    const [dataAll, setDataAll] = useState(data?.list);
    const [mainCat, setMainCat] = useState('');
    const [subCat, setSubCat] = useState('');
    const [sector, setSector] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [pageNo, setPageNo] = useState(1);



    const customStyles = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: "all .2s ease",
            // transform: state.selectProps.menuIsOpen && "rotate(180deg)"
        }),
        option: (provided, state) => ({
            ...provided,
            borderRadius: 0,
            color: state.isSelected ? `${hover}` : '#221F1F',
            backgroundColor: state.isSelected ? `rgba(232, 231, 231, 0.6)` : '#FFF',
            margin: 0,
            fontSize: 14,
            cursor: 'pointer',
            paddingLeft: 10,
            paddingRight: 10,
            fontWeight: state.isSelected ? 600 : 400,
            "&:hover": {
                backgroundColor: `rgba(232, 231, 231, 0.8)`,
                color: '#FFF',
                cursor: 'pointer'
            },

        }),
        menu: (provided, state) => ({
            ...provided,
            color: '#FFF',
            backgroundColor: state.isSelected ? `${hover}` : 'rgba(255,255,255,0)',
            margin: 0,
            borderRadius: 0,
            fontSize: 14,
            zIndex: 10
            // width: 200,
        }),
        menuList: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? `${hover}` : '#FFF',
            borderRadius: 0,
            fontWeight: '400',
            color: '#FFF',
            // fontSize: 14,
        }),

    };

    const options = [
        {value: 'all', label: 'All'},
        {value: 'finance', label: 'Financial Reports'},
        {value: 'equity', label: 'Equity Reports'},
        {value: 'market', label: 'Market Analysis'}
    ];

    const CaretDownIcon = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="7.414" viewBox="0 0 13.414 7.414">
            <g id="Group_15659" data-name="Group 15659" transform="translate(1479.207 -192.793) rotate(90)">
                <line id="Line_3883" data-name="Line 3883" x2="6" y2="6" transform="translate(193.5 1466.5)" fill="none"
                      stroke="#FFFFFF" strokeLinecap="round" strokeWidth="1"/>
                <line id="Line_3884" data-name="Line 3884" y1="6" x2="6" transform="translate(193.5 1472.5)" fill="none"
                      stroke="#FFFFFF" strokeLinecap="round" strokeWidth="1"/>
            </g>
        </svg>;
    };
    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <CaretDownIcon/>
            </components.DropdownIndicator>
        );
    };


    const mainCatOption = data?.filter?.main_category
    const subCatOption = data?.filter?.sub_cateogry
    const sectorOption = data?.filter?.sector


    const handleClick = async (mainCatOption, subCatOption, sectorOption, startDateOption, endDateOption, pageOption) => {


        try {
            const getResearchAPi = await getResearchApi(mainCatOption, subCatOption, sectorOption, startDateOption, endDateOption, pageOption);
            const researchData = getResearchAPi

            setDataAll(researchData?.list)
            setMainCat(mainCatOption ? mainCatOption : mainCat)
            setSubCat(subCatOption ? subCatOption : subCat)
            setSector(sectorOption ? sectorOption : sector)
            setStartDate(startDateOption ? startDateOption : startDate)
            setEndDate(endDateOption ? endDateOption : endDate)
            setPageNo(pageOption ? pageOption : pageNo)
        } catch (error) {
            console.error('Error fetching data:', error);
            setDataAll(data)

        }
    };

    const handleLoadMore = async (e,pageOption) => {

        e.preventDefault();
        const pageNumber = pageOption + 1;
        try {
            const getResearchAPi = await getResearchApi(mainCat, subCat, sector, startDate, endDate, pageNumber);
            const researchData = getResearchAPi
            setPageNo(pageNumber)

            setDataAll(researchData?.list)

        } catch (error) {
            console.error('Error fetching data:', error);
            setDataAll(data)

        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const formatDateString = (dateString) => {
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    return (
        <StyledMediaListing className='media-listing pb-200' >
            <Container>
                <Row className={'media-listing__filter'}>
                    <Col md={3}>
                        <div className="media-listing__filter__mobile">
                            <Select
                                classNamePrefix="filter"
                                onChange={(e) => {
                                    handleClick(e?.value, '', '', '', '', pageNo)
                                }}
                                isSearchable={false}
                                styles={customStyles}
                                components={{DropdownIndicator}}
                                options={mainCatOption}
                                placeholder={'Category'}
                                defaultValue={mainCatOption?.value}
                            />
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="media-listing__filter__mobile">
                            <Select
                                classNamePrefix="filter"
                                onChange={(e) => {
                                    handleClick(mainCat, e?.value, '', '', '', pageNo)
                                }}
                                isSearchable={false}
                                styles={customStyles}
                                components={{DropdownIndicator}}
                                options={subCatOption}
                                placeholder={'Sub-Sections'}
                                defaultValue={subCatOption?.value}
                            />
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="media-listing__filter__mobile">
                            <Select
                                classNamePrefix="filter"

                                onChange={(e) => {
                                    handleClick(mainCat, subCat, e?.value, '', '', pageNo)
                                }}
                                isSearchable={false}
                                styles={customStyles}
                                components={{DropdownIndicator}}
                                options={sectorOption}
                                placeholder={'Sector'}
                                defaultValue={sectorOption?.value}
                            />
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="media-listing__filter__mobile">
                            <DatePicker
                                showIcon
                                placeholderText={'Start Date'}
                                selected={startDate}
                                onChange={(date) =>  handleClick(mainCat, subCat, sector, formatDateString(date), '', pageNo)}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 48 48"
                                    >
                                        <mask id="ipSApplication0">
                                            <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                                <path
                                                    fill="#fff"
                                                    d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                                ></path>
                                            </g>
                                        </mask>
                                        <path
                                            fill="currentColor"
                                            d="M0 0h48v48H0z"
                                            mask="url(#ipSApplication0)"
                                        ></path>
                                    </svg>
                                }
                            />
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="media-listing__filter__mobile">
                            <DatePicker
                                showIcon
                                placeholderText={'End Date'}
                                selected={endDate}
                                onChange={(e) =>  {
                                    handleClick(mainCat, subCat, sector, startDate, formatDateString(e), pageNo)
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 48 48"
                                    >
                                        <mask id="ipSApplication0">
                                            <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                                <path
                                                    fill="#fff"
                                                    d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                                ></path>
                                            </g>
                                        </mask>
                                        <path
                                            fill="currentColor"
                                            d="M0 0h48v48H0z"
                                            mask="url(#ipSApplication0)"
                                        ></path>
                                    </svg>
                                }
                            />
                        </div>
                    </Col>
                </Row>

                <Row className={'download-list'}>

                    {
                        dataAll && dataAll?.length > 0 &&
                        dataAll?.map((e, index) => {

                        return (
                                <Col md={4} key={index}>
                                    <DownloadSingle title={e?.post_title} date={formatDate(e?.post_date_gmt)} link={e?.pdf}/>
                                </Col>
                            )
                        })
                    }


                    <Col className={'d-flex align-items-center justify-content-center'} md={12}>
                        <div className="" onClick={(e) => {
                            handleLoadMore(e, pageNo)
                        }}>
                            <Button margin={'60px 0 0'} src={'javascript:void(0)'} text={'Load More'}/>
                        </div>
                    </Col>
                </Row>

            </Container>
        </StyledMediaListing>
    );
};

const StyledMediaListing = styled.section`
    padding-top: 60px;
    background-color: #F4F4F4;
    .react-datepicker__header{
        background-color: #E62E43;
    }
    .react-datepicker__day--keyboard-selected, .react-datepicker__day--selected{
        background-color: #E62E43 !important;
        
    }
    .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{
        fill: #E62E43;
        color: #E62E43;
        
    }
    .react-datepicker__day--keyboard-selected{
        color: white;
    }
    .react-datepicker__view-calendar-icon input{
        width: 100%;
      
    }
    .react-datepicker__input-container .react-datepicker__calendar-icon{
        padding: 16px 0.5rem;
        right: 0;
        vertical-align: 0;
        height: 30px;
        width: 30px;
    }
    .react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header, .react-datepicker__day-name, .react-datepicker__time-name{
        color: white;
    }
     .react-datepicker__view-calendar-icon input{
         padding: 0 20px 0 0;
         border-left: 0;
         border-right: 0;
         border-top: 0;
         border-bottom: 1px solid rgba(25, 25, 25, 0.2);
         background: transparent;
         font-size: 20px;
         line-height: 28px;
         font-weight: 700;
         display: flex;
         align-items: center;
         justify-content: center;
         height: 60px;
         cursor: pointer;
         &:focus-visible{
             outline: none !important;
         }
         &:focus{
             outline: none !important;
         }
         &:focus-within{
             outline: none !important;
         }
         &::placeholder{
             font-size: 20px;
             line-height: 28px;
             font-weight: 700;
             color: #191919 !important;
             padding-left: 0px !important;
         }
         div{
             margin-top: 5px;
         }
    }

    .react-datepicker__input-container{
        width: 100%;
        border: none;
        background: transparent;
        &:focus-visible{
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
            .react-datepicker__view-calendar-icon input{
                outline: none !important;
                box-shadow: none !important;
                border: none !important;

            }
        }
        &:focus{
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
            .react-datepicker__view-calendar-icon input{
                outline: none !important;
                box-shadow: none !important;
                border: none !important;

            }
        }
    }
    
    .react-datepicker-wrapper{
        width: 100%;
        &:focus-visible{
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
            .react-datepicker__view-calendar-icon input{
                outline: none !important;
                box-shadow: none !important;
                border: none !important;

            }
        }

        &:focus{
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
            .react-datepicker__view-calendar-icon input{
                outline: none !important;
                box-shadow: none !important;
                border: none !important;

            }
        }
    }
    
    

    .media-listing__filter {
        position: relative;
        z-index: 33;
        .media-cat-list {
            display: flex;
            border-bottom: 1px solid #191919;

            li {
                a {
                    display: block;
                    padding: 15px 30px;
                    width: 100%;
                    height: 100%;
                    font-size: 16px;
                    line-height: 20px;
                    color: #191919;

                    &.active {
                        color: #FFF;
                        background: #191919;
                    }
                }
                &:not(:last-child){
                    border-right: 1px solid #191919;
                }
            }
        }
    }


    .css-13cymwt-control {
        border-radius: 0px !important;
        border-bottom: 1px solid rgba(25,25,25,0.2) !important;
        border: none;
        &:hover {
            border-bottom: 1px solid rgba(25,25,25,0.2) !important;
        }
    }

    .css-1u9des2-indicatorSeparator {
        background-color: transparent;
    }

    .css-1dimb5e-singleValue {
        font-size: 20px;
        line-height: 28px;
        font-weight: 700;
        color: #191919 !important;
        padding-top: 10px;
    }

    .css-1jqq78o-placeholder {
        font-size: 20px;
        line-height: 28px;
        font-weight: 700;
        padding-top: 10px;
        color: #191919 !important;
        padding-left: 0px !important;
        padding-top: 0px !important;
    }


    .css-yk16xz-control .css-1wa3eu0-placeholder, .css-1pahdxg-control .css-1wa3eu0-placeholder, .css-1uccc91-singleValue {
        color: #3C4348 !important;
        font-size: 14px !important;
        font-weight: bold;
        cursor: pointer;
        letter-spacing: 2px !important;
        text-transform: capitalize !important;
    }

    .filter__single-value.css-1dimb5e-singleValue {
        text-transform: capitalize;
        padding-left: 0px !important;
        padding-top: 0;
    }

    .css-1s4cg4l-indicatorContainer {
        font-size: 20px;
        line-height: 28px;
        font-weight: 700;
        color: White !important;
        margin-right: 5px !important;
    }

    .filter__control {
        border-radius: 0 !important;
        background-color: transparent !important;
        height: 60px;
        cursor: pointer;

        &--menu-is-open {
            border-radius: 0 !important;
            background-color: transparent !important;
            border: none;
        }

    }

    .filter__dropdown-indicator {
        margin-right: 5px !important;
        background-color: black;
    }
    

    @media(max-width: 767px){
        margin-top: 0;
        padding-left: 0;

    }
    .css-t3ipsp-control{
        box-shadow: none !important;
        border-color: unset !important;
        border: none !important;
        border-bottom: 1px solid rgba(25,25,25,0.2) !important;

    }
    
    @media(max-width: 767px){
        padding-top: 40px;
    }

    .css-1fdsijx-ValueContainer{
        padding-left: 0;
    }
    
    
    
    .download-list{
        margin-top: 60px;
        display: flex;
        .col-md-4{
            margin-bottom: 30px;
        }
    }

    .filter__value-container{
        padding-left: 0;
    }
    @media(max-width: 992px) and (min-width: 768px){
        .media-listing__filter{
            .col-md-3, .col-md-2 {
                flex: 0 0 33.3333%;
                max-width: 33.3333%;
                padding: 0;
            }
        }
    }
    @media(max-width: 767px){
        padding-left: 15px;
        .media-listing__filter{
            .col-md-3, .col-md-2 {
                flex: 0 0 100%;
                max-width: 100%;
                padding: 0 15px;
            }
        }
    }
    
    `;
export default MediaListing;